module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-manifest@5.15.0_gatsby@5.15.0_graphql@16.11.0/node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"icon":"/opt/buildhome/repo/src/images/favicon.png","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"4bac427b19c982811031b39f022840cf"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.15.0_babel-eslint@10.1.0_react-dom@18.3.1_react@18.3.1_typescript@5.9.3_webpack-cli@_wayvi7wntoyyp5jsyvpa5qoqdm/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
